import { SectionValueOn, ValuesOn } from './../models/default-values-on-create';
import { toNumber } from 'ng-zorro-antd/core/util';
import { PropertySourceQueueModel } from './../models/property-source-queue-model';
import { ParentChangedQueueModel } from './../models/parent-changed-queue-model';
import { Observable, Subscriber, from, of } from 'rxjs';
import { Guid } from './../models/guid';
import {
  ApprovalTemplate,
  EventType,
  RecordLine,
} from 'src/app/layout/record-model';
import {
  Field,
  FieldDataType,
  ModuleStructure,
  Section,
  WarningRegexCondition,
} from 'src/app/models/module-structure';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as g from '../globals';
import * as moment from 'moment';
import { FieldValueChangedArgs } from './field-value-changed-args';
import {
  DiscountContractObj,
  PriceQueueRequest,
  RecordCategory,
  RecordModel,
  RecordProperties,
} from './record-model';
import { CellValueChangedArgs } from './cell-value-changed-args';
import { PageHeader } from '../models/page-header';
import { SectionTableFilter } from '../models/section-table-filter';
import { FilterFieldValue, QueryParams } from '../apps/subscription/classes';
import { LineAddedArgs } from './line-added-args';
import { AdditionalButton } from '../models/additional-button';
import { LineDeletedArgs } from '../models/lineDeletedArgs';
import { CustomActionResponse } from '../models/CustomActionResult';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ModuleHeaderDataPayload } from '@app/models/module-header-data-payload';
import { SessionStorageService } from '@app/services/session-storage-service.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { LineSectionComponent } from './sections/line-section/line-section.component';

interface RecordIndexes {
  categoryById: Map<string, RecordCategory>;
  firstLineByCategoryId: Map<string, RecordLine | undefined>;
  propByLineIdThenName: Map<number, Map<string, RecordProperties>>;
}

@Injectable()
export class LayoutService {
  global = g;

  recordModelChanged = false;
  //cancelClicked = false;
  timesheetApprove$ = new EventEmitter<string>();
  constructor(
    private http: HttpClient,
    public modalService: NzModalService,
    public messageService: NzMessageService,
    public drawerService: NzDrawerService,
    public notification: NzNotificationService,
    private sessionStorageService: SessionStorageService
  ) {
    console.log('layout service');
  }

  static parentChangedQueue: ParentChangedQueueModel[] = [];
  //static propertySourceQueue: PropertySourceQueueModel[] = [];

  // tslint:disable-next-line: member-ordering
  static documentObjects = [
    'BlanketAgreement',
    'oInvoices',
    'oCorrectionInvoice',
    'oCorrectionInvoiceReversal',
    'oPurchaseRequest',
    'oCreditNotes',
    'oDeliveryNotes',
    'oReturns',
    'oOrders',
    'oQuotations',
    'oPurchaseInvoices',
    'oCorrectionPurchaseInvoice',
    'oCorrectionPurchaseInvoiceReversal',
    'oPurchaseCreditNotes',
    'oPurchaseDeliveryNotes',
    'oPurchaseReturns',
    'oPurchaseOrders',
    'oPurchaseQuotations',
    'oInventoryGenEntry',
    'oInventoryGenExit',
    'oDrafts',
    'oDownPaymentAP',
    'oDownPaymentAR',
    'oPurchaseDownPayments',
    'oDownPayments',
    'oReturnRequest',
  ];

  containerTransparentBG: boolean;
  containerAdditionalClass: string;
  footerAdditionalClass: string;
  containerFooterLeftPadding: number;
  containerTransparentBGEmitter: EventEmitter<boolean> = new EventEmitter();
  containerAdditionalClassEmitter: EventEmitter<string> = new EventEmitter();
  footerAdditionalClassEmitter: EventEmitter<string> = new EventEmitter();
  containerFooterLeftPaddingEmitter: EventEmitter<number> = new EventEmitter();
  // parentChangedQueue: ParentChangedQueueModel[] = [];
  screenSize: string;
  beforeSubmitEmitter: EventEmitter<RecordModel> = new EventEmitter();
  deleteRowEmitter: EventEmitter<LineDeletedArgs> = new EventEmitter();
  screenSizeEmitter: EventEmitter<string> = new EventEmitter();
  createNewEmitter: EventEmitter<string> = new EventEmitter();
  refreshListEmitter: EventEmitter<string> = new EventEmitter();
  fieldValueChanged: EventEmitter<FieldValueChangedArgs> = new EventEmitter();
  bomParentfieldValueChanged: EventEmitter<FieldValueChangedArgs> =
    new EventEmitter();
  cellValueChanged: EventEmitter<CellValueChangedArgs> = new EventEmitter();
  linesChanged: EventEmitter<RecordCategory> = new EventEmitter();
  lineAdded: EventEmitter<LineAddedArgs> = new EventEmitter();
  afterLoadBom: EventEmitter<LineAddedArgs> = new EventEmitter();
  lineDuplicated: EventEmitter<LineAddedArgs> = new EventEmitter();
  footerButtonClicked: EventEmitter<AdditionalButton> = new EventEmitter();
  submitObjectWithCustomData: EventEmitter<{
    recordModel: RecordModel;
    moduleStructure: ModuleStructure;
  }> = new EventEmitter();
  submitObjectWithCustomDataResult: EventEmitter<any> = new EventEmitter();

  shrinkRecordModel: EventEmitter<{
    recordModel: RecordModel;
    moduleStructure: ModuleStructure;
  }> = new EventEmitter();

  triggerValuesOnEdit = new EventEmitter<ValuesOn>();
  triggerValuesOnEditResult = new EventEmitter<any>();

  triggerValuesOnCreate = new EventEmitter<ValuesOn>();
  triggerValuesOnCreateResult = new EventEmitter<any>();

  triggerCustomTableSection = new EventEmitter<SectionValueOn>();
  triggerCustomTableSectionResult = new EventEmitter<any>();

  triggerRefreshReportResult = new EventEmitter<string>();
  triggerLinkedFieldChanged = new EventEmitter<{
    property: RecordProperties;
    value: string;
    recordModel: RecordModel;
    lineToWorkoOn: RecordLine;
    xmlTagName: string;
    moduleStructure: ModuleStructure;
  }>();

  removeObjectWithCustomData: EventEmitter<{
    recordModel: RecordModel;
    moduleStructure: ModuleStructure;
  }> = new EventEmitter();
  removeObjectWithCustomDataResult: EventEmitter<any> = new EventEmitter();

  closeDrawer: EventEmitter<any> = new EventEmitter();

  triggerInitObject: EventEmitter<{
    moduleStructure: ModuleStructure;
    actionType: string;
  }> = new EventEmitter();
  moduleStructureChanged: EventEmitter<string> = new EventEmitter();

  customPropertySourceQueue: EventEmitter<PropertySourceQueueModel> =
    new EventEmitter();

  objectLoadChanged: EventEmitter<{
    recordModel: RecordModel;
    moduleStructure: ModuleStructure;
  }> = new EventEmitter();
  pageHeaderChanged: EventEmitter<PageHeader> = new EventEmitter();

  submitDeliverSchedule = new EventEmitter<number | string>();

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${g.getToken()}`,
    }),
  };

  createCompanyURL = 'CompanyManagement/CreateNewCompanyDB';

  intervalTest;

  static isDocument(objectKey: string): boolean {
    return this.documentObjects.findIndex((x) => x === objectKey) > -1;
  }

  static HardCopyObject(object: any) {
    return JSON.parse(JSON.stringify(object));
  }

  static initQueue(http: HttpClient, layoutService: LayoutService) {
    // interval of property source queue
    //setInterval(() => {}, 1000);
  }

  static importMode = false;

  static setValue(
    recordProperty: RecordProperties,
    value: any,
    layoutService: LayoutService,
    recordModel: RecordModel,
    line: number,
    sectionTagName: string,
    moduleStructure: ModuleStructure,
    forceChanged: boolean = false
  ): void {
    if (recordProperty === undefined) {
      return;
    }

    if (recordProperty.IgnoreAutoPrice || LayoutService.importMode) {
      return;
    }

    let changeValue = false;
    if (
      (recordProperty.ValueAsObject == null ||
        recordProperty.ValueAsObject === undefined) &&
      value !== undefined
    ) {
      changeValue = true;
    } else if (
      recordProperty.ValueAsObject != null &&
      recordProperty.ValueAsObject !== undefined &&
      value === undefined
    ) {
      changeValue = true;
    } else if (
      recordProperty.ValueAsObject != null &&
      recordProperty.ValueAsObject.toString() !== value.toString()
    ) {
      if (recordProperty.DataType === FieldDataType.Date) {
        const dateValue = moment(value, 'YYYYMMDD').toDate();
        if (dateValue.toString() !== recordProperty.ValueAsObject.toString()) {
          changeValue = true;
        }
      } else {
        changeValue = true;
      }
    }
    if (changeValue || forceChanged) {
      if (recordProperty.DataType === FieldDataType.Date) {
        let parsedDate = moment(value, 'YYYYMMDD', true);
        if (parsedDate.isValid()) {
          recordProperty.ValueAsObject = parsedDate.toDate();
        } else {
          parsedDate = moment(value, 'DD/MM/YYYY', true);
          if (parsedDate.isValid()) {
            recordProperty.ValueAsObject = parsedDate.toDate();
          } else {
            parsedDate = moment(value);
            if (parsedDate.isValid()) {
              recordProperty.ValueAsObject = parsedDate.toDate();
            } else {
              recordProperty.ValueAsObject = null;
            }
          }
        }
      } else {
        recordProperty.ValueAsObject = value;
      }

      recordProperty.Value = recordProperty?.ValueAsObject?.toString();
      layoutService.triggerFieldValueChanged({
        recordModel,
        recordProperty,
        formId: '',
        line,
        sectionTagName,
        moduleStructure,
      });
    }
  }

  /*clearIntervals() {
    clearInterval(this.intervalTest);
  }*/

  loadModuleData(
    moduleId: number,
    productDataRequests: {
      newLine: RecordLine;
      childCode: any;
      field: Field;
      args: FieldValueChangedArgs;
      treeType: string;
    }[],
    baseProperties: string[],
    isBomChild: boolean,
    fromItemImport: boolean,
    parentComponent?: LineSectionComponent
  ) {
    const moduleHeaderDataPayload: ModuleHeaderDataPayload[] =
      productDataRequests.map((p) => ({
        selectedId: p.childCode,
        linkedField: '',
        uniqueKey: p.newLine.Id.toString(),
      }));

    this.getManyModuleHeaderData(moduleId, moduleHeaderDataPayload)
      .pipe(
        tap((response) => {
          const keys = Object.keys(response);
          keys.forEach((key) => {
            const lineId = Number(key);
            const productDataRequest = productDataRequests.find(
              (p) => p.newLine.Id === lineId
            );

            if (productDataRequest == null) {
              return;
            }

            if (response[key] == null) {
              if (fromItemImport) {
                let itemCode = moduleHeaderDataPayload.find(
                  (x) => x.uniqueKey === key
                );
                this.notification.error(
                  'Invalid Item',
                  'Item Code ' + itemCode.selectedId + ' not exist',
                  { nzDuration: 5000 }
                );
              }
              return;
            }

            let sectionToLookFor =
              productDataRequest.args.moduleStructure.module.Sections.find(
                (s) => s.XmlTagName === productDataRequest.args.sectionTagName
              );

            sectionToLookFor.Fields.forEach((fieldToLookFor) => {
              if (
                productDataRequest.field.LinkedModule ===
                  fieldToLookFor.LinkedModule &&
                productDataRequest.field.LinkedModuleGroup ===
                  fieldToLookFor.LinkedModuleGroup
              ) {
                const value = response[key][fieldToLookFor.LinkedField];
                productDataRequest.newLine.Properties.forEach((property) => {
                  if (property.Name === fieldToLookFor.PropertyName) {
                    property.ValueAsObject = value;

                    if (
                      baseProperties.indexOf(
                        `${productDataRequest.args.sectionTagName}.${property.Name}`
                      ) !== -1
                    ) {
                      this.triggerFieldValueChanged({
                        recordProperty: property,
                        formId: '',
                        line: productDataRequest.newLine.Id,
                        recordModel: productDataRequest.args.recordModel,
                        sectionTagName: sectionToLookFor.XmlTagName,
                        moduleStructure:
                          productDataRequest.args.moduleStructure,
                      });
                    } else {
                      //console.log(property.Name);
                    }
                  }
                });

                if (isBomChild) {
                  productDataRequest.newLine.Properties.find(
                    (x) => x.Name === 'U_ITM_BWEB_ITM_TYP'
                  ).ValueAsObject = productDataRequest.treeType;

                  this.triggerFieldValueChanged({
                    recordProperty: productDataRequest.newLine.Properties.find(
                      (x) => x.Name === 'U_ITM_BWEB_ITM_TYP'
                    ),
                    formId: '',
                    line: productDataRequest.newLine.Id,
                    recordModel: productDataRequest.args.recordModel,
                    sectionTagName: 'Document_Lines',
                    moduleStructure: productDataRequest.args.moduleStructure,
                  });
                }
              }
            });
          });
        })
      )
      .subscribe({
        next: (result) => {
          // handle result if needed
        },
        error: (err) => {
          console.error(err);
          if (parentComponent != null && parentComponent !== undefined) {
            parentComponent.bomLoading = false;
          }
        },
        complete: () => {
          if (parentComponent != null && parentComponent !== undefined) {
            setTimeout(() => {
              parentComponent.bomLoading = false;
            }, 2000);
          }
        },
      });
  }

  triggerBeforeSubmit(recordModel: RecordModel) {
    this.beforeSubmitEmitter.emit(recordModel);
  }

  triggerDeleteRow(
    recordCategory: RecordCategory,
    lineToDelete: RecordLine,
    lineToDeleteIndex: number,
    recordModel: RecordModel,
    moduleStructure: ModuleStructure
  ) {
    this.deleteRowEmitter.emit({
      recordCategory,
      lineToDelete,
      lineToDeleteIndex,
      recordModel,
      moduleStructure,
    });

    const customEvent = new CustomEvent('BWEBRowDeleted', {
      detail: {
        recordCategory,
        lineToDelete,
        lineToDeleteIndex,
      },
      bubbles: true,
      cancelable: false,
    });

    document.dispatchEvent(customEvent);
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async executePropertySourceQueue(
    req: PropertySourceQueueModel,
    subscriber: Subscriber<any>,
    recordProperty: RecordProperties
  ) {
    //req.recordProperty = recordProperty;

    this.http
      //.post(`${g.apiBaseUrl}data/GetPropertySourceQueue`, [req])
      .post(`${g.apiBaseUrl}data/GetPropertySourceQueue`, req)
      .subscribe((response: PropertySourceQueueModel) => {
        req.result = response.result;
        req.processed = true;
        setTimeout(() => {
          this.processSelectRequest(
            subscriber,
            recordProperty,
            response.result,
            req
          );
        }, 0);
      });
  }

  private processSelectRequest(
    subscriber: Subscriber<any>,
    recordProperty: RecordProperties,
    result: any,
    request: PropertySourceQueueModel
  ) {
    // if (subscriber != null) {
    //   subscriber.next(result);
    // } else if (recordProperty != null) {
    // The original array
    if (recordProperty === null) {
      if (subscriber != null) {
        subscriber.next(result);
      }
    } else {
      const oldOptionsArray = recordProperty.Options;

      // The new array of options
      const newOptionsArray = result.Values.rowsArray;
      if (!_.isEqual(oldOptionsArray, newOptionsArray)) {
        if (oldOptionsArray == null) {
          recordProperty.Options = newOptionsArray;
        } else {
          oldOptionsArray.splice(0, oldOptionsArray.length, ...newOptionsArray);
        }
      }

      if (
        recordProperty.Options !== undefined &&
        recordProperty.Options.length !== 0 &&
        recordProperty.Options[0].DBValue !== undefined
      ) {
        if (
          recordProperty.DBValue === '' &&
          recordProperty.ValueAsObject !== ''
        ) {
          recordProperty.DBValue = recordProperty.ValueAsObject;
          const option = recordProperty.Options.find(
            (opt: { DBValue: string }) => opt.DBValue === recordProperty.DBValue
          );

          if (option !== undefined) {
            recordProperty.ValueAsObject = option.Code;
          }
        } else if (
          recordProperty.DBValue !== '' &&
          recordProperty.ValueAsObject === ''
        ) {
          const option = recordProperty.Options.find(
            (opt: { DBValue: string }) => opt.DBValue === recordProperty.DBValue
          );
          if (option !== undefined) {
            recordProperty.ValueAsObject = option.Code;
          }
        }
        //}
      }
    }
  }

  async executeParentValueChanged(req: ParentChangedQueueModel) {
    if (req != null) {
      LayoutService.parentChangedQueue.push(req);
    }

    await this.sleep(5);

    if (
      LayoutService.parentChangedQueue.filter((p) => p.processing !== true)
        .length === 0
    ) {
      LayoutService.parentChangedQueue =
        LayoutService.parentChangedQueue.filter(
          (q) => !q.processed && !q.processing
        );
      return;
    }

    const queueToProcess = LayoutService.parentChangedQueue
      .filter((q) => !q.processed && !q.processing)
      // get unique requests
      .reduce((agg, curr) => {
        if (!agg.some((x) => x.requestId === curr.requestId)) {
          agg.push(curr);
        }
        return agg;
      }, [] as ParentChangedQueueModel[]);

    // ✅ limit to 1000 per payload
    const BATCH_SIZE = 1000;
    const batchToProcess = queueToProcess.slice(0, BATCH_SIZE);

    const requests: ParentChangedQueueModel[] = [];

    for (const req of batchToProcess) {
      let skipRequest = false;
      const request = requests.find((r) => r.requestId === req.requestId);
      if (request == null && skipRequest === false) {
        requests.push({
          requestId: req.requestId,
          fieldId: req.fieldId,
          moduleId: req.moduleId,
          sqlId: req.sqlId,
          valuesToSend: req.valuesToSend,
          lineId: req.lineId,
          processed: false,
          changeValue: req.changeValue,
          changedValueIndex: req.changedValueIndex,
        });
        req.processing = true;
      }
    }

    if (batchToProcess.length < queueToProcess.length) {
      setTimeout(() => {
        this.executeParentValueChanged(null);
      }, 50);
    }

    this.http
      .post(`${g.apiBaseUrl}data/GetFieldValueQueue`, requests)
      .subscribe((responses: ParentChangedQueueModel[]) => {
        for (const response of responses) {
          const req = queueToProcess.find(
            (f) => f.requestId === response.requestId
          );

          req.processed = true;
          if (req.recordPropertyToChange.PrevReadOnlyValue != null) {
            req.recordPropertyToChange.ReadOnly =
              req.recordPropertyToChange.PrevReadOnlyValue;
            req.recordPropertyToChange.PrevReadOnlyValue = undefined;
          }

          if (req.recordPropertyToChange.PrevRequiredValue != null) {
            req.recordPropertyToChange.Required =
              req.recordPropertyToChange.PrevRequiredValue;
            req.recordPropertyToChange.PrevRequiredValue = undefined;
          }

          if (response.isError) {
            console.log('Error while trying to execute a query', response);
          } else {
            if (
              req.recordPropertyToChange.ChangedValueIndex !==
              req.changedValueIndex
            ) {
              continue;
            }

            this.parentValueChanged(
              req.recordPropertyToChange,
              req.field,
              response.result,
              req.recordModel,
              req.lineId,
              req.recordCategory,
              req.moduleStructure,
              req.changeValue
            );
          }
        }
      });
  }

  moduleInformation(moduleId: string): Observable<any> {
    const url = `${g.apiBaseUrl}layout/moduleInformation?id=${moduleId}`;
    return this.sessionStorageService.getData(url);
  }

  executeQuery(queryId: number, parameters?: { [key: string]: any }) {
    let parametersQueryString = '';

    if (parameters !== undefined) {
      const keys = Object.keys(parameters);
      let index = 0;
      for (const key of keys) {
        parametersQueryString += `&parameters[${index}].Key=${key}&parameters[${index}].Value=${parameters[key]}`;
        index += 1;
      }
    }

    return this.http.get(
      `${g.apiBaseUrl}data/ExecuteQuery?id=${queryId}${parametersQueryString}`
    );
  }

  freeRecord(sourceObject: number, sourceObjectId: number | string) {
    return this.http.get(
      `${g.apiBaseUrl}data/FreeDocument?sourceObject=${sourceObject}&sourceObjectId=${sourceObjectId}`
    );
  }

  getSelectOptions(
    fieldId: number,
    sqlId: number,
    args: string[],
    vals: string[]
  ) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetPropertySource?fieldId=${fieldId}&sqlId=${sqlId}&args=${args}&vals=${vals}`
    );
  }

  getFilterFields(sectionId: number) {
    /*return this.http.get(
      `${
        g.apiBaseUrl
      }layout/GetSectionFilterFields?sectionId=${sectionId}`
    );*/

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}layout/GetSectionFilterFields?sectionId=${sectionId}`,
      JSON.stringify(sectionId),
      httpOptions
    );
  }

  changeScreenSize(newSize: string) {
    this.screenSize = newSize;
    this.screenSizeEmitter.emit(this.screenSize);
  }

  triggerFieldValueChanged(args: FieldValueChangedArgs) {
    if (args.moduleStructure === undefined) {
      console.log(
        'Triggering value changing when and the module structure is undefined:',
        args
      );
    }

    args.token = g.getToken();

    const customEvent = new CustomEvent('BWEBFieldValueChanged', {
      detail: args,
      bubbles: true,
      cancelable: false,
    });

    document.dispatchEvent(customEvent);

    this.fieldValueChanged.emit(args);
  }

  triggerBomParentFieldValueChanged(args: FieldValueChangedArgs) {
    if (args.moduleStructure === undefined) {
      console.log(
        'Triggering value changing when and the module structure is undefined:',
        args
      );
    }

    args.token = g.getToken();

    const customEvent = new CustomEvent('BWEBFieldValueChanged', {
      detail: args,
      bubbles: true,
      cancelable: false,
    });

    document.dispatchEvent(customEvent);

    this.bomParentfieldValueChanged.emit(args);
  }

  triggerFieldValueChangedCustom(args: FieldValueChangedArgs) {
    if (args.moduleStructure === undefined) {
      console.log(
        'Triggering value changing when and the module structure is undefined:',
        args
      );
    }

    args.token = g.getToken();

    const customEvent = new CustomEvent('BWEBFieldValueChanged', {
      detail: args,
      bubbles: true,
      cancelable: false,
    });

    document.dispatchEvent(customEvent);
  }

  triggerObjectLoad(args: {
    recordModel: RecordModel;
    moduleStructure: ModuleStructure;
  }) {
    console.log('triggerObjectLoad');
    if (args.moduleStructure === undefined) {
      console.log(
        'Triggering value changing when and the module structure is undefined:',
        args
      );
    }

    const customEvent = new CustomEvent('BWEBObjectLoad', {
      detail: args,
      bubbles: true,
      cancelable: false,
    });

    document.dispatchEvent(customEvent);
  }

  triggerCellValueChanged(args: CellValueChangedArgs) {
    this.cellValueChanged.emit(args);
  }

  getFilterInfo(filterId: number): Observable<any> {
    if (isNaN(filterId) || filterId == null || filterId === undefined) {
      filterId = 0;
    }
    const url = `${g.apiBaseUrl}layout/filterInfo?id=${filterId}`;
    return this.sessionStorageService.getData(url);
  }

  getMenus(parentMenuId: number, flat: boolean = false): Observable<any> {
    const url = `${g.apiBaseUrl}layout/menu?parentMenu=${parentMenuId}&flat=${flat}`;
    return this.sessionStorageService.getData(url);
  }

  getFieldDetails(linkedFieldId: number): Observable<any> {
    const url = `${g.apiBaseUrl}layout/field?id=${linkedFieldId}`;
    return this.sessionStorageService.getData(url);
  }

  getApp(id: any) {
    const url = `${g.apiBaseUrl}layout/app?id=${id}`;
    return this.sessionStorageService.getData(url);
  }

  getActions(moduleId: number): Observable<any> {
    const url = `${g.apiBaseUrl}layout/actions?moduleId=${moduleId}`;
    return this.sessionStorageService.getData(url);
  }

  getListStructure(moduleId: number): Observable<any> {
    const url = `${g.apiBaseUrl}layout/ModuleList?moduleId=${moduleId}`;
    return this.sessionStorageService.getData(url);
  }

  getAutoCompleteValidate(body: {
    moduleId: string;
    term: string;
    linkedFieldId: number;
    valuesToPass: { Key: string; Value: string }[];
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/AutoCompleteValidate`,
      JSON.stringify(body),
      httpOptions
    );
  }

  getAutoCompleteType(body: {
    moduleId: string;
    term: string;
    linkedFieldId: number;
    valuesToPass: { Key: string; Value: string }[];
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/AutoCompleteType`,
      JSON.stringify(body),
      httpOptions
    );
  }

  getListOfRecords(
    moduleId: number,
    moduleFilterId: number,
    page: number,
    pageSize: number,
    sortByField: string,
    sortByDir: string,
    term: string,
    linkedFieldId: number,
    valuesToPass: { Key: string; Value: string }[],
    filters: { [key: string]: SectionTableFilter },
    fromDraft: boolean
  ) {
    term = encodeURI(term);

    let _filters = LayoutService.HardCopyObject(filters);
    if (this.global.filterFormatDate === 'M') {
      for (let key in _filters) {
        let value = _filters[key];
        if (value.filterType == 2) {
          if (value.valueTo !== null) {
            value.valueTo = moment(
              new Date(value.valueTo).setHours(0, 0, 0, 0)
            ).format(this.global.companyConfiguration.MomentDateFormat);
          }
          if (value.valueFrom !== null) {
            value.valueFrom = moment(
              new Date(value.valueFrom).setHours(0, 0, 0, 0)
            ).format(this.global.companyConfiguration.MomentDateFormat);
          }
          if (value.singleValue !== null) {
            value.singleValue = moment(
              new Date(value.singleValue).setHours(0, 0, 0, 0)
            ).format(this.global.companyConfiguration.MomentDateFormat);
          }
        }
      }
    } else {
      for (let key in _filters) {
        let value = _filters[key];
        if (value.filterType == 2) {
          if (value.valueTo !== null) {
            value.valueTo = moment(
              new Date(value.valueTo).setHours(0, 0, 0, 0)
            ).format('yyyy-MM-DD');
          }
          if (value.valueFrom !== null) {
            value.valueFrom = moment(
              new Date(value.valueFrom).setHours(0, 0, 0, 0)
            ).format('yyyy-MM-DD');
          }
          if (value.singleValue !== null) {
            value.singleValue = moment(
              new Date(value.singleValue).setHours(0, 0, 0, 0)
            ).format('yyyy-MM-DD');
          }
        }
      }
    }
    const body = {
      moduleId,
      moduleFilterId,
      page,
      pageSize,
      sortByField,
      sortByDir,
      term,
      linkedFieldId,
      valuesToPass,
      filters: _filters,
      fromDraft,
    };

    return this.http.post(`${g.apiBaseUrl}data/records`, JSON.stringify(body));
  }

  exportTheRecords(
    moduleId: number,
    moduleFilterId: number,
    page: number,
    pageSize: number,
    sortByField: string,
    sortByDir: string,
    term: string,
    linkedFieldId: number,
    valuesToPass: { Key: string; Value: string }[],
    filters: { [key: string]: SectionTableFilter },
    fromDraft: boolean,
    exportType: string
  ) {
    term = encodeURI(term);
    const body = {
      moduleId,
      moduleFilterId,
      page,
      pageSize,
      sortByField,
      sortByDir,
      term,
      linkedFieldId,
      valuesToPass,
      filters,
      fromDraft,
    };

    return this.http.post(
      `${g.apiBaseUrl}data/ExportRecords?exportType=${exportType}`,
      JSON.stringify(body)
    );
  }

  getModuleStructure(moduleId: number): Observable<ModuleStructure> {
    const url = `${g.apiBaseUrl}layout/ModuleStructure?moduleId=${moduleId}`;
    return this.sessionStorageService.getData(url);
  }

  setCustomConditionForModule(moduleId: number, conditions: string) {
    const url = `${g.apiBaseUrl}data/SetCustomConditionForModule?moduleId=${moduleId}`;
    return this.http.post(url, conditions);
  }

  resetCustomCondition(moduleId: number) {
    const url = `${g.apiBaseUrl}data/ResetCustomCondition?moduleId=${moduleId}`;
    return this.http.post(url, null);
  }

  getModuleHeaderData(
    moduleId: number | string,
    selectedId: string | number | Date,
    linkedField: string,
    fromDraft: boolean
  ) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetModuleHeaderData?moduleId=${moduleId}&selectedId=${selectedId}&linkedField=${linkedField}&fromDraft=${fromDraft}`
    );
  }
  getManyModuleHeaderData(
    moduleId: number,
    payload: ModuleHeaderDataPayload[]
  ) {
    return this.http.post(
      `${g.apiBaseUrl}data/GetManyModuleHeaderData?moduleId=${moduleId}`,
      payload
    );
  }

  moduleIdByType(moduleId: string, ModuleApp = ''): Observable<any> {
    const modApp = ModuleApp !== '' ? `&ModuleApp=${ModuleApp}` : '';
    const url = `${g.apiBaseUrl}layout/ModuleIdByType?type=${moduleId}${modApp}`;
    return this.sessionStorageService.getData(url);
  }

  ModuleFilters(moduleId): Observable<any> {
    const url = `${g.apiBaseUrl}layout/GetModuleFilterOptions?moduleId=${moduleId}`;
    return this.sessionStorageService.getData(url);
  }

  getSelectValuesSync(
    fieldId: number,
    sqlId: number,
    args: string[],
    vals: string[]
  ) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetPropertySource?fieldId=${fieldId}&sqlId=${sqlId}&args=${args}&vals=${vals}`
    );
  }

  getSelectValues(
    moduleStructure: ModuleStructure,
    dataSourcePath: string,
    fieldId: number,
    sqlId: number,
    args: string[],
    vals: string[]
  ) {
    const result = new Observable<any>((subscriber) => {
      const request = {
        id: Guid.newGuid(),
        fieldId,
        sqlId,
        args,
        vals,
        processed: false,
        processing: false,
        resultReceived: false,
        result: null,
        dataSourcePath,
      };

      this.executePropertySourceQueue(request, subscriber, null);
    });

    return result;
  }

  getSelectValuesForProperty(
    moduleStructure: ModuleStructure,
    dataSourcePath: string,
    fieldId: number,
    sqlId: number,
    args: string[],
    vals: string[],
    recordProperty: RecordProperties
  ) {
    // const cachedDataPrefix = `cachedData-${g.userIdentity.CompanyDB}-${g.userIdentity.RoleId}-options-`;
    // const cachedValue =
    //   window.sessionStorage[
    //     cachedDataPrefix + sqlId + JSON.stringify(args) + JSON.stringify(vals)
    //   ];

    const request: PropertySourceQueueModel = {
      id: Guid.newGuid(),
      fieldId,
      sqlId,
      args,
      vals,
      processed: false,
      processing: false,
      resultReceived: false,
      result: null,
    };

    // if (cachedValue) {
    //   const result = JSON.parse(cachedValue);
    //   request.recordProperty = recordProperty;

    //   this.processSelectRequest(null, result, request);
    // } else {
    this.executePropertySourceQueue(request, null, recordProperty);
    //}
  }

  NUMERIC_TYPES = new Set([
    FieldDataType.Number,
    FieldDataType.Amount,
    FieldDataType.AmountFromDocument,
    FieldDataType.Integer,
    FieldDataType.Percent,
    FieldDataType.Price,
    FieldDataType.PriceFromDocument,
    FieldDataType.PriceLines,
    FieldDataType.PriceLocalCurrency,
    FieldDataType.PriceSystemCurrency,
    FieldDataType.Quantity,
  ]);

  defaultForType(dt: FieldDataType): string {
    return this.NUMERIC_TYPES.has(dt) ? '0' : '';
  }

  // Cache indexes on the model to avoid rebuilding 1500x
  ensureIndexes(recordModel: RecordModel): RecordIndexes {
    const anyModel = recordModel as any;
    if (anyModel.__idx) return anyModel.__idx as RecordIndexes;

    const categoryById = new Map<string, RecordCategory>();
    const firstLineByCategoryId = new Map<string, RecordLine | undefined>();
    const propByLineIdThenName = new Map<
      number,
      Map<string, RecordProperties>
    >();

    for (const cat of recordModel.Categories ?? []) {
      categoryById.set(cat.Id, cat);
      firstLineByCategoryId.set(cat.Id, cat.Lines?.[0]);
      for (const line of cat.Lines ?? []) {
        let propMap = propByLineIdThenName.get(line.Id);
        if (!propMap) {
          propMap = new Map<string, RecordProperties>();
          propByLineIdThenName.set(line.Id, propMap);
        }
        for (const p of line.Properties ?? []) {
          propMap.set(p.Name, p);
        }
      }
    }

    anyModel.__idx = {
      categoryById,
      firstLineByCategoryId,
      propByLineIdThenName,
    };
    return anyModel.__idx;
  }

  getPropertyByName(
    line: RecordLine | undefined,
    name: string,
    idx: RecordIndexes
  ): RecordProperties | undefined {
    if (!line) return undefined;
    return line.Properties.find((p) => p.Name === name);
    //return idx.propByLineIdThenName.get(line.Id)?.get(name);
  }

  // Call with `this` bound (uses this.formatDatetime)
  extractValueFromProperty(
    this: any,
    prop: RecordProperties | undefined
  ): string {
    if (!prop) return '';
    let value = prop.DBValue;

    if (
      value === undefined ||
      value === null ||
      value === '' ||
      value === '0'
    ) {
      if (
        prop.DataType === FieldDataType.Date &&
        prop.ValueAsObject !== undefined &&
        prop.ValueAsObject !== null &&
        prop.ValueAsObject !== ''
      ) {
        return this.formatDatetime(new Date(prop.ValueAsObject), 'yyyyMMDD');
      }
      value = prop.ValueAsObject as unknown as string;
      if (
        (value === undefined || value === null || value === '') &&
        this.NUMERIC_TYPES.has(prop.DataType)
      ) {
        value = '0';
      }
    }
    return (value ?? '').toString();
  }

  getFieldValueOnParentChange(
    recordModel: RecordModel,
    recordCategory: RecordCategory,
    recordLine: RecordLine,
    recordPropertyToChange: RecordProperties,
    sqlId: number,
    field: Field,
    moduleStructure: ModuleStructure,
    changeValue: boolean
  ) {
    const parametersInQuery: string[] | undefined = g.queriesData[sqlId];
    if (!parametersInQuery || parametersInQuery.length === 0) return;

    const idx = this.ensureIndexes(recordModel);

    // Unique params (preserve order)
    const seen = new Set<string>();
    const valuesToSend: { Code: string; Value: string }[] = [];
    for (const code of parametersInQuery) {
      if (!seen.has(code)) {
        seen.add(code);
        valuesToSend.push({ Code: code, Value: '' });
      }
    }

    const fieldDefault = this.defaultForType(field.DataType);

    for (const item of valuesToSend) {
      const code = item.Code;
      const dot = code.indexOf('.');
      const paramSectionXmlTagName = dot === -1 ? code : code.slice(0, dot);
      const paramFieldPropertyName = dot === -1 ? '' : code.slice(dot + 1);

      // Start with default based on the current field's data type (matches original behavior)
      let value: string = fieldDefault;

      if (paramSectionXmlTagName === recordCategory.Id) {
        // Current category → current line
        const prop = this.getPropertyByName(
          recordLine,
          paramFieldPropertyName,
          idx
        );
        if (prop) value = this.extractValueFromProperty.call(this, prop);
      } else {
        // Other category → first line in that category
        const otherLine = idx.firstLineByCategoryId.get(paramSectionXmlTagName);
        const prop = this.getPropertyByName(
          otherLine,
          paramFieldPropertyName,
          idx
        );
        if (prop) {
          // Keep the exact original fallback order for "other category"
          let v: any = prop.DBValue;
          if (v === undefined || v === null || v === '' || v === '0') {
            if (
              prop.DataType === FieldDataType.Date &&
              ((prop.ValueAsObject !== undefined &&
                prop.ValueAsObject !== null &&
                prop.ValueAsObject !== '') ||
                (prop.Value !== undefined &&
                  prop.Value !== null &&
                  prop.Value !== ''))
            ) {
              v = this.formatDatetime(new Date(prop.ValueAsObject), 'yyyyMMDD');
            } else {
              if (
                prop.ValueAsObject !== undefined &&
                prop.ValueAsObject !== null &&
                prop.ValueAsObject !== ''
              ) {
                v = prop.ValueAsObject as unknown as string;
              } else {
                v = prop.Value as unknown as string;
              }
            }
          }
          value = (v ?? '').toString();
        }
      }

      item.Value = value ?? '';
    }

    // Maintain original counters/flags
    if (recordPropertyToChange.ChangedValueIndex == null) {
      recordPropertyToChange.ChangedValueIndex = 0;
    }
    recordPropertyToChange.ChangedValueIndex += 1;

    const parentChangedReq: ParentChangedQueueModel = {
      requestId: Guid.newGuid(),
      fieldId: field.Id,
      moduleId: moduleStructure.module.Id,
      sqlId,
      valuesToSend,
      recordPropertyToChange,
      field,
      recordModel,
      lineId: recordLine.Id,
      recordCategory,
      moduleStructure,
      processed: false,
      changeValue,
      changedValueIndex: recordPropertyToChange.ChangedValueIndex,
    };

    // ReadOnly / Required logic (no setInterval storms)
    if (recordPropertyToChange.PrevReadOnlyValue == null) {
      if (recordPropertyToChange.ReadOnly == null) {
        if (recordModel.EventType === EventType.Update) {
          recordPropertyToChange.ReadOnly =
            field.Editable === false ? true : field.ReadOnly;
        } else {
          recordPropertyToChange.ReadOnly = field.ReadOnly;
        }
      }
      // If you previously relied on polling before pushing, prefer a microtask:
      // queueMicrotask(() => LayoutService.pushToParentChangedQueue(parentChangedReq, this));
    }

    if (recordPropertyToChange.PrevRequiredValue == null) {
      if (recordPropertyToChange.Required == null) {
        recordPropertyToChange.Required = field.Required;
      }
      recordPropertyToChange.PrevRequiredValue =
        recordPropertyToChange.Required;
      // queueMicrotask(() => LayoutService.pushToParentChangedQueue(parentChangedReq, this));
    }

    // Push now (or switch to a batched/idle strategy below)
    LayoutService.pushToParentChangedQueue(parentChangedReq, this);
  }

  getFieldValueValidationOnChange(
    recordModel: RecordModel,
    recordCategory: RecordCategory,
    recordLine: RecordLine,
    sqlId: number,
    field: Field,
    moduleStructure: ModuleStructure
  ) {
    const parametersInQuery = g.queriesData[sqlId];
    if (parametersInQuery == null) {
      return;
    }
    const valuesToSend: { Code: string; Value: string }[] = [];
    for (const param of parametersInQuery) {
      if (valuesToSend.filter((c) => c.Code === param).length === 0) {
        valuesToSend.push({ Code: param, Value: '' });
      }
    }

    for (const valueToSend of valuesToSend) {
      const paramSectionXmlTagName = valueToSend.Code.split('.')[0];
      const paramFieldPropertyName = valueToSend.Code.split('.')[1];

      if (paramSectionXmlTagName === recordCategory.Id) {
        let value = '';
        if (
          [
            FieldDataType.Number,
            FieldDataType.Amount,
            FieldDataType.AmountFromDocument,
            FieldDataType.Integer,
            FieldDataType.Percent,
            FieldDataType.Price,
            FieldDataType.PriceFromDocument,
            FieldDataType.PriceLines,
            FieldDataType.PriceLocalCurrency,
            FieldDataType.PriceSystemCurrency,
            FieldDataType.Quantity,
          ].indexOf(field.DataType) !== -1
        ) {
          value = '0';
        }
        //const recordLine = recordCategory.Lines.find((l) => l.Id === lineId);
        let recordProperty: RecordProperties = null;
        recordLine.Properties.forEach((property) => {
          if (property.Name === paramFieldPropertyName) {
            recordProperty = property;
          }
        });
        if (recordProperty != null) {
          value = recordProperty.DBValue;
          if (
            value === undefined ||
            value == null ||
            value === '' ||
            value === '0'
          ) {
            if (
              recordProperty.DataType === FieldDataType.Date &&
              recordProperty.ValueAsObject !== undefined &&
              recordProperty.ValueAsObject !== null &&
              recordProperty.ValueAsObject !== ''
            ) {
              value = this.formatDatetime(
                new Date(recordProperty.ValueAsObject),
                'yyyyMMDD'
              );
            } else {
              value = recordProperty.ValueAsObject;
              if (
                (value === undefined || value == null || value === '') &&
                [
                  FieldDataType.Number,
                  FieldDataType.Amount,
                  FieldDataType.AmountFromDocument,
                  FieldDataType.Integer,
                  FieldDataType.Percent,
                  FieldDataType.Price,
                  FieldDataType.PriceFromDocument,
                  FieldDataType.PriceLines,
                  FieldDataType.PriceLocalCurrency,
                  FieldDataType.PriceSystemCurrency,
                  FieldDataType.Quantity,
                ].indexOf(recordProperty.DataType) !== -1
              ) {
                value = '0';
              }
            }
          }
        }

        valueToSend.Value = value;
      } else {
        let value = '';
        if (
          [
            FieldDataType.Number,
            FieldDataType.Amount,
            FieldDataType.AmountFromDocument,
            FieldDataType.Integer,
            FieldDataType.Percent,
            FieldDataType.Price,
            FieldDataType.PriceFromDocument,
            FieldDataType.PriceLines,
            FieldDataType.PriceLocalCurrency,
            FieldDataType.PriceSystemCurrency,
            FieldDataType.Quantity,
          ].indexOf(field.DataType) !== -1
        ) {
          value = '0';
        }
        let fieldRecordCategory: RecordCategory;

        recordModel.Categories.forEach((category) => {
          if (category.Id === paramSectionXmlTagName) {
            fieldRecordCategory = category;
          }
        });

        if (
          fieldRecordCategory != null &&
          fieldRecordCategory.Lines.length > 0
        ) {
          const recordLine = fieldRecordCategory.Lines[0];
          let recordProperty: RecordProperties = null;
          recordLine.Properties.forEach((property) => {
            if (property.Name === paramFieldPropertyName) {
              recordProperty = property;
            }
          });
          if (recordProperty != null) {
            value = recordProperty.DBValue;
            if (
              value === undefined ||
              value == null ||
              value === '' ||
              value === '0'
            ) {
              if (
                recordProperty.DataType === FieldDataType.Date &&
                recordProperty.ValueAsObject !== undefined &&
                recordProperty.ValueAsObject !== null &&
                recordProperty.ValueAsObject !== ''
              ) {
                value = this.formatDatetime(
                  new Date(recordProperty.ValueAsObject),
                  'yyyyMMDD'
                );
              } else {
                value = recordProperty.ValueAsObject;
              }
            }
          }
        }

        valueToSend.Value = value;
      }
    }

    return this.http.post(
      `${g.apiBaseUrl}data/GetFieldValueValidationOnChange?moduleId=${moduleStructure.module.Id}&sqlId=${sqlId}`,
      valuesToSend
    );
  }

  getWarningMsgOnValueChange(
    recordModel: RecordModel,
    recordCategory: RecordCategory,
    recordLine: RecordLine,
    sqlId: number,
    field: Field,
    moduleStructure: ModuleStructure
  ) {
    const parametersInQuery = g.queriesData[sqlId];
    if (parametersInQuery == null) {
      return;
    }
    const valuesToSend: { Code: string; Value: string }[] = [];
    for (const param of parametersInQuery) {
      if (valuesToSend.filter((c) => c.Code === param).length === 0) {
        valuesToSend.push({ Code: param, Value: '' });
      }
    }

    for (const valueToSend of valuesToSend) {
      const paramSectionXmlTagName = valueToSend.Code.split('.')[0];
      const paramFieldPropertyName = valueToSend.Code.split('.')[1];

      if (paramSectionXmlTagName === recordCategory.Id) {
        let value = '';
        if (
          [
            FieldDataType.Number,
            FieldDataType.Amount,
            FieldDataType.AmountFromDocument,
            FieldDataType.Integer,
            FieldDataType.Percent,
            FieldDataType.Price,
            FieldDataType.PriceFromDocument,
            FieldDataType.PriceLines,
            FieldDataType.PriceLocalCurrency,
            FieldDataType.PriceSystemCurrency,
            FieldDataType.Quantity,
          ].indexOf(field.DataType) !== -1
        ) {
          value = '0';
        }
        //const recordLine = recordCategory.Lines.find((l) => l.Id === lineId);
        let recordProperty: RecordProperties = null;
        recordLine.Properties.forEach((property) => {
          if (property.Name === paramFieldPropertyName) {
            recordProperty = property;
          }
        });
        if (recordProperty != null) {
          value = recordProperty.DBValue;
          if (
            value === undefined ||
            value == null ||
            value === '' ||
            value === '0'
          ) {
            if (
              recordProperty.DataType === FieldDataType.Date &&
              recordProperty.ValueAsObject !== undefined &&
              recordProperty.ValueAsObject !== null &&
              recordProperty.ValueAsObject !== ''
            ) {
              value = this.formatDatetime(
                new Date(recordProperty.ValueAsObject),
                'yyyyMMDD'
              );
            } else {
              value = recordProperty.ValueAsObject;
              if (
                (value === undefined || value == null || value === '') &&
                [
                  FieldDataType.Number,
                  FieldDataType.Amount,
                  FieldDataType.AmountFromDocument,
                  FieldDataType.Integer,
                  FieldDataType.Percent,
                  FieldDataType.Price,
                  FieldDataType.PriceFromDocument,
                  FieldDataType.PriceLines,
                  FieldDataType.PriceLocalCurrency,
                  FieldDataType.PriceSystemCurrency,
                  FieldDataType.Quantity,
                ].indexOf(recordProperty.DataType) !== -1
              ) {
                value = '0';
              }
            }
          }
        }

        valueToSend.Value = value;
      } else {
        let value = '';
        if (
          [
            FieldDataType.Number,
            FieldDataType.Amount,
            FieldDataType.AmountFromDocument,
            FieldDataType.Integer,
            FieldDataType.Percent,
            FieldDataType.Price,
            FieldDataType.PriceFromDocument,
            FieldDataType.PriceLines,
            FieldDataType.PriceLocalCurrency,
            FieldDataType.PriceSystemCurrency,
            FieldDataType.Quantity,
          ].indexOf(field.DataType) !== -1
        ) {
          value = '0';
        }
        let fieldRecordCategory: RecordCategory;

        recordModel.Categories.forEach((category) => {
          if (category.Id === paramSectionXmlTagName) {
            fieldRecordCategory = category;
          }
        });

        if (
          fieldRecordCategory != null &&
          fieldRecordCategory.Lines.length > 0
        ) {
          const recordLine = fieldRecordCategory.Lines[0];
          let recordProperty: RecordProperties = null;
          recordLine.Properties.forEach((property) => {
            if (property.Name === paramFieldPropertyName) {
              recordProperty = property;
            }
          });
          if (recordProperty != null) {
            value = recordProperty.DBValue;
            if (
              value === undefined ||
              value == null ||
              value === '' ||
              value === '0'
            ) {
              if (
                recordProperty.DataType === FieldDataType.Date &&
                recordProperty.ValueAsObject !== undefined &&
                recordProperty.ValueAsObject !== null &&
                recordProperty.ValueAsObject !== ''
              ) {
                value = this.formatDatetime(
                  new Date(recordProperty.ValueAsObject),
                  'yyyyMMDD'
                );
              } else {
                value = recordProperty.ValueAsObject;
              }
            }
          }
        }

        valueToSend.Value = value;
      }
    }

    return this.http.post(
      `${g.apiBaseUrl}data/GetWarningMsgOnValueChange?moduleId=${moduleStructure.module.Id}&sqlId=${sqlId}`,
      valuesToSend
    );
  }

  static pushToParentChangedQueue(
    request: ParentChangedQueueModel,
    layoutService: LayoutService
  ) {
    const values = LayoutService.parentChangedQueue;
    const oldIndex = values.findIndex(
      (x) =>
        x.fieldId == request.fieldId &&
        x.sqlId == request.sqlId &&
        x.lineId === request.lineId
    );

    if (oldIndex !== -1) {
      values.splice(oldIndex, 1);
    }

    LayoutService.parentChangedQueue = LayoutService.parentChangedQueue.filter(
      (p) => !(p.fieldId === request.fieldId && p.lineId === request.lineId)
    );

    layoutService.executeParentValueChanged(request);
  }

  private parentValueChanged(
    recordPropertyToChange: RecordProperties,
    field: Field,
    d: any,
    recordModel: RecordModel,
    lineId: number,
    recordCategory: RecordCategory,
    moduleStructure: ModuleStructure,
    changeValue: boolean
  ) {
    if (d == null) return;

    const oldValue = recordPropertyToChange.ValueAsObject;
    const addInfo = field.AdditionalInformationParsed;

    let allowSetValue = true;
    if (recordCategory.Id === 'Document_Lines') {
      let recordLine = recordCategory.Lines.find((l) => l.Id === lineId);
      let treeType = recordLine.Properties.find(
        (p) => p.Name === 'TreeType'
      )?.ValueAsObject;
      if (
        (treeType === 'iIngredient' || treeType === 'I') &&
        addInfo.ValueFromParentIfChild
      ) {
        allowSetValue = false;
      }
    }

    let linkedFieldInQuery = addInfo.LinkedFieldInQuery;
    if (
      Object.keys(d).indexOf(linkedFieldInQuery) === -1 &&
      linkedFieldInQuery === 'Value'
    ) {
      linkedFieldInQuery = Object.keys(d)[0];
    }

    if (d[linkedFieldInQuery] != null && d[linkedFieldInQuery] !== undefined) {
      if (oldValue !== d[linkedFieldInQuery] && changeValue) {
        if (!recordPropertyToChange.ForceKeepValue && allowSetValue) {
          LayoutService.setValue(
            recordPropertyToChange,
            d[linkedFieldInQuery],
            this,
            recordModel,
            lineId,
            recordCategory.Id,
            moduleStructure
          );
        }
        recordPropertyToChange.ForceKeepValue = false;
      }

      if (d[addInfo.LinkedFieldInMinValue] !== undefined) {
        recordPropertyToChange.MinValue = d[addInfo.LinkedFieldInMinValue];
      }

      if (d[addInfo.LinkedFieldInMaxValue] !== undefined) {
        recordPropertyToChange.MaxValue = d[addInfo.LinkedFieldInMaxValue];
      }

      if (d[addInfo.LinkedFieldMinValueToolTip] !== undefined) {
        recordPropertyToChange.MinValueToolTip =
          d[addInfo.LinkedFieldMinValueToolTip];
      }

      if (d[addInfo.LinkedFieldMaxValueToolTip] !== undefined) {
        recordPropertyToChange.MaxValueToolTip =
          d[addInfo.LinkedFieldMaxValueToolTip];
      }

      if (d[addInfo.LinkedFieldInReadonly] !== undefined) {
        recordPropertyToChange.ReadOnly =
          d[addInfo.LinkedFieldInReadonly] === 'Y';
      }
      if (d[addInfo.LinkedFieldInRequired] !== undefined) {
        recordPropertyToChange.Required =
          d[addInfo.LinkedFieldInRequired] === 'Y';
      }
      if (d[addInfo.LinkedFieldInVisible] !== undefined) {
        recordPropertyToChange.Visible =
          d[addInfo.LinkedFieldInVisible] === 'Y';
        field.AdditionalInformationParsed.Visible =
          d[addInfo.LinkedFieldInVisible] === 'Y';
      }
    } else {
      if (allowSetValue) {
        LayoutService.setValue(
          recordPropertyToChange,
          '',
          this,
          recordModel,
          lineId,
          recordCategory.Id,
          moduleStructure
        );
      }
    }
  }

  formatDatetime(date: Date, format: string) {
    const padStart = (value: number): string =>
      value.toString().padStart(2, '0');

    return moment(date).format(format);
  }

  getDefaultValue(queryId: number) {
    if (queryId === 80116) {
      const guid = Guid.newGuid();
      return of({ DefaultValue: guid });
    } else {
      return this.http.get(
        `${g.apiBaseUrl}data/GetDefaultValue?queryId=${queryId}`
      );
    }
  }

  getDefaultValuesOnCreate(
    moduleStructure: ModuleStructure,
    id: number,
    actionType: number = -1,
    selectedId: string = '',
    sourceObject: number = null,
    BPCardCode: string = '',
    items: string = '',
    customActionCode: string = '',
    contactId: string = ''
  ) {
    if (moduleStructure.module.AdditionalInformationParsed.IsCustomData) {
      this.triggerValuesOnCreate.next({
        moduleStructure,
        id,
        actionType,
        selectedId,
        sourceObject,
        BPCardCode,
        items,
        customActionCode,
        contactId,
      });

      return this.triggerValuesOnCreateResult;
    } else {
      return this.http.get(
        `${g.apiBaseUrl}data/GetDefaultValuesOnCreate?id=${id}&actionType=${actionType}&sourceObject=${sourceObject}&BPCardCode=${BPCardCode}&items=${items}&customActionCode=${customActionCode}&contactId=${contactId}&selectedId=${selectedId}`
      );
    }
  }

  getValuesOnEdit(
    moduleStructure: ModuleStructure,
    id: number,
    selectedId: string | number,
    fromDraft: boolean = false,
    fromLog: boolean = false,
    logInstance: number = 0,
    linkedField: string = ''
  ) {
    if (
      moduleStructure !== null &&
      moduleStructure.module.AdditionalInformationParsed.IsCustomData
    ) {
      this.triggerValuesOnEdit.emit({
        moduleStructure,
        id,
        selectedId,
      });

      return this.triggerValuesOnEditResult;
    } else {
      const selectedIdStr = selectedId.toString(); //.replace('%3B', '~');

      if (selectedIdStr.indexOf('~') !== -1) {
        return this.http.get(
          `${g.apiBaseUrl}data/Edit?id=${id}&selectedId=${
            selectedIdStr.split('~')[0]
          }&secondaryId=${
            selectedIdStr.split('~')[1]
          }&fromDraft=${fromDraft}&fromLog=${fromLog}&logInstance=${logInstance}&linkedField=${linkedField}`
        );
      } else {
        return this.http.get(
          `${g.apiBaseUrl}data/Edit?id=${id}&selectedId=${selectedId}&fromDraft=${fromDraft}&fromLog=${fromLog}&logInstance=${logInstance}&linkedField=${linkedField}`
        );
      }
    }
  }
  getChangeLog(docType: string, docEntry: string) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetChangeLog?docEntry=${docEntry}&docType=${docType}`
    );
  }

  getCustomerAnnouncement(email: string) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetCustomerAnnouncement?email=${email}`
    );
  }

  setCustomerAnnouncement(
    AnnouncementCode: string,
    cardCode: string,
    contactCode: string,
    email: string
  ) {
    return this.http.get(
      `${g.apiBaseUrl}data/setCustomerAnnouncement?AnnouncementCode=${AnnouncementCode}&cardCode=${cardCode}&contactCode=${contactCode}&email=${email}`
    );
  }

  getDifferenceBetweenTwoInstances(
    id: number,
    selectedId: string | number,
    logInstance1: number = 0,
    logInstance2: number = 0
  ) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetDifferenceBetweenTwoInstances?id=${id}&selectedId=${selectedId}&secondaryId=&logInstance1=${logInstance1}&logInstance2=${logInstance2}`
    );
  }

  compareObjects(object1, object2, key) {
    const obj1 = object1[key];
    const obj2 = object2[key];

    if (obj1 < obj2) {
      return -1;
    }
    if (obj1 > obj2) {
      return 1;
    }
    return 0;
  }

  translate(value: string): string {
    if (value == null || value === undefined) {
      return '';
    }
    const translateRow = g.translationsData.find(
      (t) => t.OrigianlText.toLowerCase() === value.toString().toLowerCase()
    );
    if (translateRow !== undefined && translateRow != null) {
      if (translateRow.Id === 0) {
        if (translateRow.TranslatedText === '') {
          return value;
        } else {
          return translateRow.TranslatedText;
        }
      } else {
        return translateRow.TranslatedText;
      }
    } else {
      g.translationsData.push({
        Id: 0,
        OrigianlText: value,
        TranslatedText: '',
        Language: localStorage.getItem('language'),
      });

      //this.addTranslation(value, value, localStorage.getItem('language'));
      return value;
    }
  }

  addTranslation(originalText: string, translateText: string, lang: string) {
    this.http
      .get(
        `${g.apiBaseUrl}Miscellaneous/AddTranslation?originalText=${originalText}&translatedText=${translateText}&lang=${lang}`
      )
      .subscribe((d) => {});
  }

  CreateDownPayment(recordModel: RecordModel, amount: number) {
    for (const category of recordModel.Categories) {
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            if (
              prop.ValueAsObject !== null &&
              prop.ValueAsObject !== undefined &&
              prop.ValueAsObject !== ''
            ) {
              if (prop.DataType === FieldDataType.Date) {
                prop.Value = moment(prop.ValueAsObject).format(
                  g.companyConfiguration.MomentDateFormat
                );
              } else {
                prop.Value = prop.ValueAsObject.toString();
              }
            } else {
              prop.Value = '';
            }
          }
        }
      }
    }

    for (const cat of recordModel.Categories) {
      for (const line of cat.Lines) {
        for (let k = 0; k < line.Properties.length; k++) {
          const prop = line.Properties[k];
          if (prop.Disabled) {
            line.Properties.splice(k, 1);
            k -= 1;
          }
        }
      }
    }

    const strData = JSON.stringify(recordModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/CreateDownPayment?amount=${amount}`,
      strData,
      httpOptions
    );
  }

  CreateIncomingPayment(recordModel: RecordModel, amount: number) {
    for (const category of recordModel.Categories) {
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            if (
              prop.ValueAsObject !== null &&
              prop.ValueAsObject !== undefined &&
              prop.ValueAsObject !== ''
            ) {
              if (prop.DataType === FieldDataType.Date) {
                prop.Value = moment(prop.ValueAsObject).format(
                  g.companyConfiguration.MomentDateFormat
                );
              } else {
                prop.Value = prop.ValueAsObject.toString();
              }
            } else {
              prop.Value = '';
            }
          }
        }
      }
    }

    for (const cat of recordModel.Categories) {
      for (const line of cat.Lines) {
        for (let k = 0; k < line.Properties.length; k++) {
          const prop = line.Properties[k];
          if (prop.Disabled) {
            line.Properties.splice(k, 1);
            k -= 1;
          }
        }
      }
    }

    const strData = JSON.stringify(recordModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/CreateIncomingPayment?amount=${amount}`,
      strData,
      httpOptions
    );
  }

  UpdateContract(recordModel: RecordModel) {
    for (const category of recordModel.Categories) {
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            if (
              prop.ValueAsObject !== null &&
              prop.ValueAsObject !== undefined &&
              prop.ValueAsObject !== ''
            ) {
              if (prop.DataType === FieldDataType.Date) {
                prop.Value = moment(prop.ValueAsObject).format(
                  g.companyConfiguration.MomentDateFormat
                );
              } else {
                prop.Value = prop.ValueAsObject.toString();
              }
            } else {
              prop.Value = '';
            }
          }
        }
      }
    }

    for (const cat of recordModel.Categories) {
      for (const line of cat.Lines) {
        for (let k = 0; k < line.Properties.length; k++) {
          const prop = line.Properties[k];
          if (prop.Disabled) {
            line.Properties.splice(k, 1);
            k -= 1;
          }
        }
      }
    }

    const strData = JSON.stringify(recordModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/UpdateContract`,
      strData,
      httpOptions
    );
  }

  SaveContractDiscount(recordModel: RecordModel) {
    for (const category of recordModel.Categories) {
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            if (
              prop.ValueAsObject !== null &&
              prop.ValueAsObject !== undefined &&
              prop.ValueAsObject !== ''
            ) {
              if (prop.DataType === FieldDataType.Date) {
                prop.Value = moment(prop.ValueAsObject).format(
                  g.companyConfiguration.MomentDateFormat
                );
              } else {
                prop.Value = prop.ValueAsObject.toString();
              }
            } else {
              prop.Value = '';
            }
          }
        }
      }
    }

    for (const cat of recordModel.Categories) {
      for (const line of cat.Lines) {
        for (let k = 0; k < line.Properties.length; k++) {
          const prop = line.Properties[k];
          if (prop.Disabled) {
            line.Properties.splice(k, 1);
            k -= 1;
          }
        }
      }
    }

    const strData = JSON.stringify(recordModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/SaveContractDiscount`,
      strData,
      httpOptions
    );
  }

  CreateInitialsInvoice(recordModel: RecordModel) {
    for (const category of recordModel.Categories) {
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            if (
              prop.ValueAsObject !== null &&
              prop.ValueAsObject !== undefined &&
              prop.ValueAsObject !== ''
            ) {
              if (prop.DataType === FieldDataType.Date) {
                prop.Value = moment(prop.ValueAsObject).format(
                  g.companyConfiguration.MomentDateFormat
                );
              } else {
                prop.Value = prop.ValueAsObject.toString();
              }
            } else {
              prop.Value = '';
            }
          }
        }
      }
    }

    for (const cat of recordModel.Categories) {
      for (const line of cat.Lines) {
        for (let k = 0; k < line.Properties.length; k++) {
          const prop = line.Properties[k];
          if (prop.Disabled) {
            line.Properties.splice(k, 1);
            k -= 1;
          }
        }
      }
    }

    const strData = JSON.stringify(recordModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/GenerateInvoicesFromPayment`,
      strData,
      httpOptions
    );
  }

  getOpenQuotationRows(cardCode: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/OpenQuotationRows?cardCode=${cardCode}`,
      '',
      httpOptions
    );
  }

  getOpenDocumentRows(
    moduleId: string,
    sourceTable: string,
    cardCode: string,
    documentType: string
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/OpenDocumentRows?moduleId=${moduleId}&sourceTable=${sourceTable}&cardCode=${cardCode}&documentType=${documentType}`,
      '',
      httpOptions
    );
  }

  getSourceDocument(sourceDocument: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}data/GetSourceDocument?sourceDocument=${sourceDocument}`,
      '',
      httpOptions
    );
  }

  removeObject(recordModel: RecordModel, moduleStructure: ModuleStructure) {
    const copyRecordModel = JSON.parse(
      JSON.stringify(recordModel)
    ) as RecordModel;
    if (
      moduleStructure !== null &&
      moduleStructure.module.AdditionalInformationParsed.IsCustomData
    ) {
      this.removeObjectWithCustomData.emit({
        recordModel: copyRecordModel,
        moduleStructure,
      });

      return this.removeObjectWithCustomDataResult;
    }
  }

  checkObjectApprove(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    newVersion
  ) {
    const copyRecordModel = JSON.parse(
      JSON.stringify(recordModel)
    ) as RecordModel;

    if (newVersion) {
      copyRecordModel.EventType = EventType.Create;
    }

    let errors = '';
    const warningMessages = [];
    for (const category of copyRecordModel.Categories) {
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            const verificationResult = this.verifyFieldValue(
              line,
              prop,
              moduleStructure,
              null
            );

            prop.Options = [];

            if (verificationResult.error != null) {
              errors += verificationResult.error;
            }

            if (verificationResult.warningMessage != null) {
              warningMessages.push(verificationResult.warningMessage);
            }
          }
        }
      }
    }

    if (errors !== '') {
      const result = new Observable<any>((subscriber) => {
        subscriber.next({
          Has_Error: true,
          Error_Message: errors,
        });
      });

      return result;
    }

    const strData = JSON.stringify(copyRecordModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    if (warningMessages.length === 0) {
      /*return this.http.post(
        `${g.apiBaseUrl}data/CheckApprove?saveToFinal=false`,
        strData,
        httpOptions
      );*/

      const params = new HttpParams().set('saveToFinal', 'false');

      const formData = new FormData();

      // If `strData` is a string that you want to treat as a file
      const blob = new Blob([strData], { type: 'text/plain' });
      formData.append('file', blob, 'data.txt');

      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });

      return this.http.post(`${g.apiBaseUrl}data/CheckApprove_File`, formData, {
        ...httpOptions,
        params,
      });
    } else {
      const result = new Observable<any>((subscriber) => {
        this.checkObjectApproveWithWarning(
          subscriber,
          warningMessages,
          warningMessages[0],
          strData,
          httpOptions
        );
      });

      return result;
    }
  }

  checkObjectApproveWithWarning(
    subscriber: Subscriber<any>,
    warningMessages: any[],
    warningMessage: any,
    strData: string,
    httpOptions: { headers: HttpHeaders }
  ) {
    const layoutService = this;
    this.modalService.confirm({
      nzTitle: warningMessage.Message,
      nzContent: '',
      nzOnCancel: () => {
        subscriber.next({
          Has_Error: true,
          FromWarning: true,
        });
      },
      nzOnOk: () => {
        if (warningMessages.length === 1) {
          /*layoutService.http
            .post(
              `${g.apiBaseUrl}data/CheckApprove?saveToFinal=false`,
              strData,
              httpOptions
            )
            .subscribe((s) => subscriber.next(s));*/

          const params = new HttpParams().set('saveToFinal', 'false');

          const formData = new FormData();

          // If `strData` is a string that you want to treat as a file
          const blob = new Blob([strData], { type: 'text/plain' });
          formData.append('file', blob, 'data.txt');

          Object.keys(params).forEach((key) => {
            formData.append(key, params[key]);
          });

          layoutService.http
            .post(`${g.apiBaseUrl}data/CheckApprove_File`, formData, {
              ...httpOptions,
            })
            .subscribe((s) => subscriber.next(s));
        } else {
          warningMessages.splice(0, 1);
          layoutService.checkObjectApproveWithWarning(
            subscriber,
            warningMessages,
            warningMessages[0],
            strData,
            httpOptions
          );
        }
      },
    });
  }

  saveDraftDocumentToFinal(recordModel: RecordModel, docEntry: number) {
    const copyRecordModel = JSON.parse(
      JSON.stringify(recordModel)
    ) as RecordModel;

    let errors = '';
    for (const category of copyRecordModel.Categories) {
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            if (
              prop.ValueAsObject !== null &&
              prop.ValueAsObject !== undefined &&
              prop.ValueAsObject !== ''
            ) {
              if (prop.DataType === FieldDataType.Date) {
                prop.Value = moment(prop.ValueAsObject).format(
                  g.companyConfiguration.MomentDateFormat
                );
                prop.ValueAsObject = moment(prop.ValueAsObject).format(
                  g.companyConfiguration.MomentDateFormat
                );
              } else if (prop.DataType === FieldDataType.Time) {
                prop.ValueAsObject = moment(prop.ValueAsObject).format('HH:mm');
                prop.Value = moment(prop.ValueAsObject).format('HH:mm');
              } else {
                prop.Value = prop.ValueAsObject.toString();
              }
            } else {
              prop.Value = '';
              if (prop.Required) {
                errors += `<li>${this.translate(
                  'Please fill the following field:'
                )} ${this.translate(prop.Label)}</li>`;
              }
            }
          }
        }
      }
    }

    const strData = JSON.stringify(copyRecordModel);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    const params = new HttpParams().set('DocEntry', docEntry.toString());

    const formData = new FormData();

    // If `strData` is a string that you want to treat as a file
    const blob = new Blob([strData], { type: 'text/plain' });
    formData.append('file', blob, 'data.txt');

    // If you also want to send additional params
    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    return this.http.post(
      `${g.apiBaseUrl}data/SaveDraftDocumentToFinal_File`,
      formData,
      {
        ...httpOptions,
        params,
      }
    );

    /*return this.http.post(
      `${g.apiBaseUrl}data/SaveDraftDocumentToFinal?DocEntry=${docEntry}`,
      strData,
      httpOptions
    );*/
  }

  submitObject(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    newVersion: boolean,
    approvalTemplates: ApprovalTemplate[] = [],
    saveAsDraft: boolean = false
  ) {
    // let x = JSON.stringify(recordModel);
    const copyRecordModel = JSON.parse(
      JSON.stringify(recordModel)
    ) as RecordModel;

    if (newVersion) {
      copyRecordModel.EventType = EventType.Create;
    }

    let errors = '';
    const warningMessages = [];
    for (const category of copyRecordModel.Categories) {
      category.DeletedLines = [];
      for (const line of category.Lines) {
        if (line !== undefined) {
          for (const prop of line.Properties) {
            const verificationResult = this.verifyFieldValue(
              line,
              prop,
              moduleStructure,
              approvalTemplates
            );

            prop.Options = [];

            if (verificationResult.error != null) {
              errors += verificationResult.error;
            }

            if (verificationResult.warningMessage != null) {
              warningMessages.push(verificationResult.warningMessage);
            }
          }
        }
      }
    }

    for (const category of copyRecordModel.Categories) {
      category.DeletedLines = [];

      if (category.hasOwnProperty('AdditionalIdentifier')) {
        delete category['AdditionalIdentifier'];
      }
      if (category.hasOwnProperty('AlwaysHasDefaultValue')) {
        delete category['AlwaysHasDefaultValue'];
      }

      for (const line of category.Lines) {
        if (line !== undefined) {
          if (line.hasOwnProperty('QuantityProp')) {
            delete line['QuantityProp'];
          }
          if (line.hasOwnProperty('OpenQtyProp')) {
            delete line['OpenQtyProp'];
          }
          if (line.hasOwnProperty('BaseItemCodeProp')) {
            delete line['BaseItemCodeProp'];
          }
          if (line.hasOwnProperty('TreeTypeProp')) {
            delete line['TreeTypeProp'];
          }
          if (line.hasOwnProperty('ItemCodeProp')) {
            delete line['ItemCodeProp'];
          }
          if (line.hasOwnProperty('LineTemplateHtml')) {
            delete line['LineTemplateHtml'];
          }
          if (line.hasOwnProperty('CssClass')) {
            delete line['CssClass'];
          }
          if (line.hasOwnProperty('Visible')) {
            delete line['Visible'];
          }

          for (const prop of line.Properties) {
            if (prop.hasOwnProperty('ExecuteParentChangeOnLoad')) {
              delete prop.ExecuteParentChangeOnLoad;
            }
            if (prop.hasOwnProperty('AdditionalInformation')) {
              delete prop['AdditionalInformation'];
            }
            if (prop.hasOwnProperty('LoadingOptionsIndex')) {
              delete prop['LoadingOptionsIndex'];
            }
            if (prop.hasOwnProperty('EscapedValue')) {
              delete prop['EscapedValue'];
            }
            if (prop.hasOwnProperty('Escape')) {
              delete prop['Escape'];
            }
            if (prop.hasOwnProperty('Options')) {
              delete prop['Options'];
            }
            if (prop.hasOwnProperty('Initialized')) {
              delete prop['Initialized'];
            }
            if (prop.hasOwnProperty('InTable')) {
              delete prop['InTable'];
            }
            if (prop.hasOwnProperty('Visible')) {
              delete prop['Visible'];
            }
            if (prop.hasOwnProperty('Required')) {
              delete prop['Required'];
            }
            if (prop.hasOwnProperty('Label')) {
              delete prop['Label'];
            }
            if (
              prop.hasOwnProperty('AdditionalInformationModel') &&
              prop['AdditionalInformationModel']?.SAPFSControl === null
            ) {
              delete prop['AdditionalInformationModel'];
            }

            if (prop.hasOwnProperty('IsHTML') && prop['IsHTML'] === false) {
              delete prop['IsHTML'];
            }

            if (prop.hasOwnProperty('IsImage') && prop['IsImage'] === false) {
              delete prop['IsImage'];
            }

            if (prop.hasOwnProperty('Disabled') && prop['Disabled'] === false) {
              delete prop['Disabled'];
            }

            if (
              prop.hasOwnProperty('FieldName') &&
              prop['FieldName'] === 'U_ITM_DELIVER_SCHEDULE'
            ) {
              if (prop.hasOwnProperty('Value')) {
                delete prop['Value'];
              }
            }
            if (
              prop.hasOwnProperty('DataType') &&
              (prop['DataType'] === 1 || prop['DataType'] === 11)
            ) {
              if (prop.hasOwnProperty('Value')) {
                delete prop['Value'];
              }
            }
            if (prop.hasOwnProperty('DataType') && prop['DataType'] !== 3) {
              if (prop.hasOwnProperty('DBValue')) {
                delete prop['DBValue'];
              }
            }
          }
        }
      }
    }

    if (errors !== '') {
      if (errors !== '') {
        return new Observable<any>((subscriber) => {
          subscriber.next({
            Has_Error: true,
            Error_Message: errors,
          });
        });
      }
    }

    if (
      copyRecordModel.Categories.find((x) => x.Id === 'Document_Lines') !=
        null &&
      copyRecordModel.Categories.find((x) => x.Id === 'Document_Lines') !==
        undefined &&
      copyRecordModel.Categories.find((x) => x.Id === 'Document_Lines').Lines
        .length <= 0
    ) {
      return new Observable<any>((subscriber) => {
        subscriber.next({
          Has_Error: true,
          Error_Message: 'There is no items to submit',
        });
      });
    }

    if (
      copyRecordModel.Categories.find((x) => x.Id === 'Document_Lines') !=
        null &&
      copyRecordModel.Categories.find((x) => x.Id === 'Document_Lines') !==
        undefined &&
      copyRecordModel.EventType === EventType.Create
    ) {
      const documentLines = copyRecordModel.Categories.find(
        (x) => x.Id === 'Document_Lines'
      );

      let index = 0;
      let specialLineProcessed: number[] = [];
      documentLines.Lines.forEach((line) => {
        let lineId = line.Id;
        line.Id = index++;
        line.Properties.find((p) => p.Name === 'LineNum').ValueAsObject =
          line.Id;
        line.Properties.find((p) => p.Name === 'LineNum').Value =
          line.Id.toString();
        if (
          lineId !== line.Id &&
          specialLineProcessed.findIndex((x) => x === lineId) === -1
        ) {
          const spLines = documentLines.SpecialLines.filter(
            (sl) => sl.AftLineNum === lineId
          );
          if (spLines != null && spLines !== undefined && spLines.length > 0) {
            specialLineProcessed.push(line.Id);
            spLines.forEach((element) => {
              element.AftLineNum = line.Id;
            });
          }
        }
      });
    }

    const documentSection = copyRecordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );

    if (
      documentSection != null &&
      documentSection !== undefined &&
      copyRecordModel.EventType === EventType.Create
    ) {
      const versionOnBaseEntryProp = documentSection.Lines[0].Properties.find(
        (x) => x.Name === 'VersionOnBaseEntry'
      );
      if (
        versionOnBaseEntryProp != null &&
        versionOnBaseEntryProp !== undefined
      ) {
        if (newVersion) {
          documentSection.Lines[0].Properties.find(
            (x) => x.Name === 'VersionOnBaseEntry'
          ).Value = copyRecordModel.KeyValue;
          documentSection.Lines[0].Properties.find(
            (x) => x.Name === 'VersionOnBaseEntry'
          ).ValueAsObject = copyRecordModel.KeyValue;
        } else {
          documentSection.Lines[0].Properties.find(
            (x) => x.Name === 'VersionOnBaseEntry'
          ).Value = '';
          documentSection.Lines[0].Properties.find(
            (x) => x.Name === 'VersionOnBaseEntry'
          ).ValueAsObject = '';
        }
      }
    }

    const result = new Observable<any>((subscriber) => {
      if (warningMessages.length > 0) {
        this.submitObjectWithWarningMessage(
          subscriber,
          warningMessages,
          warningMessages[0],
          copyRecordModel,
          recordModel,
          approvalTemplates,
          moduleStructure,
          saveAsDraft
        );
      } else {
        this.submitObjectFinalStep(
          subscriber,
          copyRecordModel,
          recordModel,
          approvalTemplates,
          moduleStructure,
          saveAsDraft
        );
      }
    });

    return result;
  }

  verifyFieldValue(
    line: RecordLine,
    prop: RecordProperties,
    moduleStructure: ModuleStructure,
    approvalTemplates: ApprovalTemplate[]
  ) {
    let error: string = null;
    let warningMessage: {} = null;

    if (
      prop.ValueAsObject !== null &&
      prop.ValueAsObject !== undefined &&
      prop.ValueAsObject !== ''
    ) {
      if (prop.DataType === FieldDataType.Date) {
        prop.Value = moment(prop.ValueAsObject).format(
          g.companyConfiguration.MomentDateFormat
        );
        prop.ValueAsObject = moment(prop.ValueAsObject).format(
          g.companyConfiguration.MomentDateFormat
        );
      } else if (prop.DataType === FieldDataType.Time) {
        prop.ValueAsObject = moment(prop.ValueAsObject).format('HH:mm');
        prop.Value = prop.ValueAsObject;
      } else {
        prop.Value = prop.ValueAsObject.toString();
      }
    } else {
      prop.Value = '';
      let isChild = false;
      if (line.hasOwnProperty('TreeTypeProp')) {
        isChild =
          line['TreeTypeProp'].ValueAsObject === 'I' ||
          line['TreeTypeProp'].ValueAsObject === 'iIngredient';
      }
      if (
        prop.Required &&
        (prop.Name !== 'U_ITM_DELIVER_SCHEDULE' ||
          (prop.Name === 'U_ITM_DELIVER_SCHEDULE' && !isChild))
      ) {
        if (
          prop.Label == null ||
          prop.Label === undefined ||
          prop.Label === ''
        ) {
          moduleStructure.module.Sections.forEach((s) => {
            const foundedField = s.Fields.find((f) => f.Id === prop.FieldId);

            if (foundedField != null) {
              prop.Label = foundedField.Label;
              return;
            }
          });
        }

        error = `<li>${this.translate(
          'Please fill the following field:'
        )} ${this.translate(prop.Label)}</li>`;
      }
    }

    if (approvalTemplates == null || approvalTemplates.length == 0) {
      let field: Field;
      moduleStructure.module.Sections.forEach((s) => {
        const foundedField = s.Fields.find((f) => f.Id === prop.FieldId);

        if (foundedField != null) {
          field = foundedField;
        }
      });

      if (
        field != null &&
        field.AdditionalInformationParsed.WarningMessageEnabled
      ) {
        const regex = new RegExp(
          field.AdditionalInformationParsed.WarningRegex
        );
        const checkResult = regex.test(prop.Value);
        if (
          checkResult &&
          field.AdditionalInformationParsed.WarningRegexCondition ===
            WarningRegexCondition.Match
        ) {
          warningMessage = {
            FieldId: field.Id,
            Message: this.translate(
              field.AdditionalInformationParsed.WarningMessageText
            ).replace('_label_', this.translate(prop.Label)),
          };
        } else if (
          !checkResult &&
          field.AdditionalInformationParsed.WarningRegexCondition ===
            WarningRegexCondition.NoMatch
        ) {
          warningMessage = {
            FieldId: field.Id,
            Message: this.translate(
              field.AdditionalInformationParsed.WarningMessageText
            ).replace('_label_', this.translate(prop.Label)),
          };
        }
      }
    }

    return { error, warningMessage };
  }

  submitObjectWithWarningMessage(
    subscriber: Subscriber<any>,
    warningMessages: any[],
    warningMessage: any,
    copyRecordModel: RecordModel,
    recordModel: RecordModel,
    approvalTemplates: ApprovalTemplate[],
    moduleStructure: ModuleStructure,
    saveAsDraft: boolean
  ) {
    const layoutService = this;
    this.modalService.confirm({
      nzTitle: warningMessage.Message,
      nzContent: '',
      nzOnCancel: () => {
        subscriber.next({
          Has_Error: true,
          FromWarning: true,
        });
      },
      nzOnOk: () => {
        if (warningMessages.length === 1) {
          layoutService.submitObjectFinalStep(
            subscriber,
            copyRecordModel,
            recordModel,
            approvalTemplates,
            moduleStructure,
            saveAsDraft
          );
        } else {
          warningMessages.splice(0, 1);
          layoutService.submitObjectWithWarningMessage(
            subscriber,
            warningMessages,
            warningMessages[0],
            copyRecordModel,
            recordModel,
            approvalTemplates,
            moduleStructure,
            saveAsDraft
          );
        }
      },
    });
  }

  submitObjectFinalStep(
    subscriber: Subscriber<any>,
    copyRecordModel: RecordModel,
    recordModel: RecordModel,
    approvalTemplates: ApprovalTemplate[],
    moduleStructure: ModuleStructure,
    saveAsDraft: boolean
  ) {
    this.shrinkRecordModel.emit({
      recordModel: copyRecordModel,
      moduleStructure,
    });

    //if (copyRecordModel.KeyValue.indexOf('~') !== -1) {
    //  copyRecordModel.KeyValue = copyRecordModel.KeyValue.split('~')[0];
    //}
    const strData = JSON.stringify(copyRecordModel);
    const strApprovalTemplates = JSON.stringify(approvalTemplates);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${g.getToken()}`,
      }),
    };

    if (
      moduleStructure !== null &&
      moduleStructure.module.AdditionalInformationParsed.IsCustomData
    ) {
      this.submitObjectWithCustomData.emit({
        recordModel: copyRecordModel,
        moduleStructure,
      });

      this.submitObjectWithCustomDataResult.subscribe((s) => {
        subscriber.next(s);
      });
    } else if (recordModel.ObjectKey === 'COMPANY_CREATE') {
      if (recordModel.EventType === EventType.Create) {
        this.http
          .get(
            `${g.baseUrl}CompanyManagement/CreateNewCompanyDB?payload=${strData}`
          )
          .subscribe((s) => {
            subscriber.next(s);
          });
      } else if (recordModel.EventType === EventType.Update) {
        this.http
          .get(
            `${g.baseUrl}CompanyManagement/UpdateCompanyInfo?payload=${strData}`
          )
          .subscribe((s) => {
            subscriber.next(s);
          });
      }
    } else {
      const params = new HttpParams()
        .set('withValidation', 'true')
        .set('approvalTemplates', strApprovalTemplates)
        .set('saveAsDraft', saveAsDraft.toString());

      // this.http
      //   .post(`${g.apiBaseUrl}data/CreateObject`, strData, {
      //     ...httpOptions,
      //     params,
      //   })
      //   .subscribe((s) => {
      //     subscriber.next(s);
      //   });

      const formData = new FormData();

      // If `strData` is a string that you want to treat as a file
      const blob = new Blob([strData], { type: 'text/plain' });
      formData.append('file', blob, 'data.txt');

      // If you also want to send additional params
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });

      this.http
        .post(`${g.apiBaseUrl}data/CreateObject_File`, formData, {
          ...httpOptions,
          params,
        })
        .subscribe((s) => {
          subscriber.next(s);
        });
    }
  }

  getSectionTableColumns(sectionId: number): Observable<any> {
    const url = `${g.apiBaseUrl}layout/GetSectionTableColumns?sectionId=${sectionId}`;
    return this.sessionStorageService.getData(url);
  }

  getSection(sectionId: number): Observable<any> {
    const url = `${g.apiBaseUrl}layout/GetSection?sectionId=${sectionId}`;
    return this.sessionStorageService.getData(url);
  }

  // i am here
  getSectionTableData(
    section: Section,
    queryId: number,
    objectKey: string,
    moduleId: number,
    sectionId: number,
    filterData: FilterFieldValue[] = null,
    objectType: string = 'section'
  ) {
    if (
      section !== undefined &&
      section !== null &&
      section.AdditionalInformationParsed.IsCustomData
    ) {
      this.triggerCustomTableSection.emit({ section, objectKey });

      return this.triggerCustomTableSectionResult;
    } else {
      if (objectKey === undefined) {
        objectKey = '0';
      }
      if (filterData != null) {
        return this.http.get(
          `${
            g.apiBaseUrl
          }data/GetSectionTableData?queryId=${queryId}&objectType=${objectType}&moduleId=${moduleId}&sectionId=${sectionId}&objectKey=${objectKey}&queryParams=${JSON.stringify(
            filterData
          )}`
        );
      } else {
        return this.http.get(
          `${g.apiBaseUrl}data/GetSectionTableData?queryId=${queryId}&objectType=${objectType}&moduleId=${moduleId}&sectionId=${sectionId}&objectKey=${objectKey}`
        );
      }
    }
  }

  getItemPrice(params: PriceQueueRequest) {
    const strData = JSON.stringify(params);

    return this.http.post(`${g.apiBaseUrl}data/GetItemPrice`, strData);
  }

  // added by tom
  // GET
  ExecuteGetDiscountLineValues(
    docEntry: string,
    numMonth: number,
    lineNum: number,
    discountPercent: number,
    fromDate: string
  ) {
    return this.http.get(
      `${g.apiBaseUrl}data/ExecuteGetDiscountLineValues?docEntry=${docEntry}&numMonth=${numMonth}&lineNum=${lineNum}&discountPercent=${discountPercent}&fromDate=${fromDate}`
    );
  }

  executeGetDueAmount(
    docEntry: number,
    endOfMonth: boolean,
    numMonth: number,
    discounts: DiscountContractObj[]
  ) {
    return this.http.get(
      `${
        g.apiBaseUrl
      }data/ExecuteGetDueAmount?docEntry=${docEntry}&endOfMonth=${endOfMonth}&numMonth=${numMonth}&discountsStr=${JSON.stringify(
        discounts
      )}`
    );
  }

  // end

  getDataFromQuery(queryId, filterData: FilterFieldValue[]) {
    const queryParams = new QueryParams();
    queryParams.QueryId = queryId;
    queryParams.FilterFields = filterData;

    return this.http.post(
      `${g.apiBaseUrl}data/GetDataFromQuery?page=0&pageSize=0`,
      JSON.stringify(queryParams),
      this.httpOptions
    );
  }
  // end

  getEmployeesList() {
    return this.http.get(`${g.apiBaseUrl}ApiCommunication/GetEmployeesList`);
  }

  getDocumentCardCode(docType: string, docEntry: string) {
    return this.http.post(
      `${g.apiBaseUrl}ApiCommunication/GetDocumentCardCode?docType=${docType}&selectedId=${docEntry}`,
      '',
      this.httpOptions
    );
  }

  activitiesList(docType, selectedId) {
    return this.http.get(
      `${g.apiBaseUrl}ApiCommunication/ActivityList?docType=${docType}&selectedId=${selectedId}`
    );
  }

  getScripts() {
    const url = `${g.apiBaseUrl}Layout/Scripts`;
    return this.sessionStorageService.getData(url);
  }

  getStyles() {
    const url = `${g.apiBaseUrl}Layout/Styles`;
    return this.sessionStorageService.getData(url);
  }

  getStylesUnauthorized() {
    return this.http.get(`${g.apiBaseUrl}Miscellaneous/Styles`);
  }

  getScriptsUnauthorized() {
    return this.http.get(`${g.apiBaseUrl}Miscellaneous/Scripts`);
  }

  parameterDataSource(searchTxt, queryId = 2301) {
    return this.http.get(
      `${g.apiBaseUrl}Report/ParameterDataSource?queryId=${queryId}&search=${searchTxt}`
    );
  }

  getAllowedCommunicationTypes() {
    return this.http.get(
      `${g.apiBaseUrl}ApiCommunication/AllowedCommunicationTypes`
    );
  }

  getCommunicationConfigs() {
    return this.http.get(
      `${g.apiBaseUrl}ApiCommunication/GetCommunicationConfigs`
    );
  }

  createCommunication(queryParams) {
    return this.http.post(
      `${g.apiBaseUrl}ApiCommunication/create`,
      JSON.stringify(queryParams),
      this.httpOptions
    );
  }
  postComment(
    moduleId: number,
    DocEntry: string,
    objType: number,
    notes: string,
    emailSubject: string,
    emailBody: string
  ) {
    return this.http.post(`${g.apiBaseUrl}ApiCommunication/PostComment`, {
      moduleId,
      DocEntry,
      objType,
      notes,
      emailSubject,
      emailBody,
    });
  }

  getConfiguration(configCode) {
    return this.sessionStorageService.getData(
      `${g.apiBaseUrl}Layout/GetConfiguration?configCode=${configCode}`
    );
  }

  getConfigurationFromCompany(configCode) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetConfigurationFromCompany?configCode=${configCode}`
    );
  }

  SendMessage(queryParams) {
    return this.http.post(
      `${g.apiBaseUrl}APIMessage/SendMessage?fromCommunication=true&trackData=true`,
      // `${g.apiBaseUrl}Mailing/SendMessage?fromCommunication=true&trackData=true`,
      JSON.stringify(queryParams),
      this.httpOptions
    );
  }
  GetEmailTemplateInfo(moduleId) {
    return this.http.get(
      `${g.apiBaseUrl}ApiCommunication/GetEmailTemplateInfo?moduleId=${moduleId}`
    );
  }
  GetOpportunityDocument(id) {
    return this.http.get(
      `${g.apiBaseUrl}ApiCommunication/GetOpportunityDoc?id=${id}`
    );
  }
  getDocumentRelations(docEntry, objectType, fullMap) {
    docEntry = toNumber(docEntry);
    return this.http.get(
      `${g.apiBaseUrl}ApiDocument/DocumentRelationData?docEntry=${docEntry}&objectType=${objectType}&fullMap=${fullMap}`
    );
  }

  pushDataToBackend(
    jsonToPush: string,
    actionCode: string,
    dataToProcess: string
  ): Observable<CustomActionResponse> {
    return this.http.post<CustomActionResponse>(
      `${g.apiBaseUrl}data/PushDataToBackend`,
      JSON.stringify({ jsonToPush, actionCode, dataToProcess }),
      this.httpOptions
    );
  }

  ChangeLoggedCompany(contactId: number, company, token = false) {
    return this.http.post(
      `${g.apiBaseUrl}Expose/ChangeLoggedCompany?contactId=${contactId}&company=${company}`,
      null
    );
  }
  getContactCompanies(contactCode, company) {
    return this.http.get(
      `${g.apiBaseUrl}Expose/GetContactCompanies?contactId=${contactCode}&company=${company}`
    );
  }
  setLanguage(value) {
    return this.http.get(`${g.apiBaseUrl}Expose/SetLang?value=${value}`);
  }
  setLanguageLogin(value) {
    return this.http.get(
      `${g.apiBaseUrl}ExternalAccount/SetLang?value=${value}`
    );
  }
  GetLayoutsByIds(ids: number[]) {
    return this.http.post(
      `${g.apiBaseUrl}APIMessage/GetLayoutInfo`,
      ids,
      this.httpOptions
    );
  }
  ExecuteMethodOfModule(
    moduleId: number,
    methodName: string,
    selectedIds: string
  ) {
    return this.http.get(
      `${g.apiBaseUrl}Layout/ExecuteMethodOfModule?id=${moduleId}&method=${methodName}&selectedIds=${selectedIds}`
    );
  }

  getAtpReport(itemCode: string, warehouse: string) {
    return this.http.get(
      `${g.apiBaseUrl}data/GetATPReport?itemCode=${itemCode}&warehouse=${warehouse}`
    );
  }

  modifyModuleField(
    fieldId: number,
    selectedId: number,
    newValue: string,
    selectedId2?: number
  ): Observable<any> {
    let params = new HttpParams()
      .set('fieldId', fieldId.toString())
      .set('selectedId', selectedId.toString())
      .set('newValue', newValue);

    if (selectedId2 !== undefined) {
      params = params.set('selectedId2', selectedId2.toString());
    }

    return this.http.get(`${g.apiBaseUrl}data/ModifyModuleField`, { params });
  }
}
